import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { userReducer, usersMiddleWare } from './state/users';
import { pagesReducer } from './state/pages';
import { productsReducer } from './state/products';

// import { LOCAL_STORAGE_STATE } from './state/localstorage';

import { productApi } from './api/product'
import { productsApi } from './api/products'
import { suggestionsApi } from './api/suggestions';

export const store = configureStore({
  reducer: combineReducers({
    pages: pagesReducer,
    user: userReducer,
    products: productsReducer,
    [productApi.reducerPath]: productApi.reducer,
    [productsApi.reducerPath]: productsApi.reducer,
    [suggestionsApi.reducerPath]: suggestionsApi.reducer,
  }),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(productApi.middleware)
    .concat(productsApi.middleware)
    .concat(suggestionsApi.middleware)
    // .concat(productsMiddleWare)
    .concat(usersMiddleWare),
  // preloadedState: LOCAL_STORAGE_STATE || {} // FIXME, users load initial state from storage but does not work. Blinking login effect.
});

export type RootState = ReturnType<typeof store.getState>
